export default "__VITE_PUBLIC_ASSET__9dbe1110__"